import { render, staticRenderFns } from "./ProfileUserLimits.vue?vue&type=template&id=2cad5d1c&scoped=true"
import script from "./ProfileUserLimits.vue?vue&type=script&lang=js"
export * from "./ProfileUserLimits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cad5d1c",
  null
  
)

export default component.exports